var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDrop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 5
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "drop_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M10 0 5 5 0 0Z",
  clipRule: "evenodd",
  "data-name": "Path 894"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "drop_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h1920v966H0Z",
  "data-name": "Path 893"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#drop_svg__a)",
  "data-name": "Group 360"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#drop_svg__b)",
  "data-name": "Group 359",
  transform: "translate(-1279 -373)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1294 383h-20v-15h20Z",
  "data-name": "Path 892"
})))));
export { SvgDrop as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iZHJvcCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjEwIiBoZWlnaHQ9IjUiIHZpZXdCb3g9IjAgMCAxMCA1Ij4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcC1wYXRoIj4KICAgICAgPHBhdGggaWQ9IlBhdGhfODk0IiBkYXRhLW5hbWU9IlBhdGggODk0IiBkPSJNMTctMTQsMTItOSw3LTE0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcgMTQpIiBmaWxsPSJub25lIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz4KICAgIDwvY2xpcFBhdGg+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aC0yIj4KICAgICAgPHBhdGggaWQ9IlBhdGhfODkzIiBkYXRhLW5hbWU9IlBhdGggODkzIiBkPSJNLTEyNzItNjAySDY0OFYzNjRILTEyNzJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjcyIDYwMikiIGZpbGw9Im5vbmUiLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgogIDxnIGlkPSJHcm91cF8zNjAiIGRhdGEtbmFtZT0iR3JvdXAgMzYwIiBjbGlwLXBhdGg9InVybCgjY2xpcC1wYXRoKSI+CiAgICA8ZyBpZD0iR3JvdXBfMzU5IiBkYXRhLW5hbWU9Ikdyb3VwIDM1OSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyNzkgLTM3MykiIGNsaXAtcGF0aD0idXJsKCNjbGlwLXBhdGgtMikiPgogICAgICA8cGF0aCBpZD0iUGF0aF84OTIiIGRhdGEtbmFtZT0iUGF0aCA4OTIiIGQ9Ik0yMi00SDJWLTE5SDIyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTI3MiAzODcpIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";